<div class="tp-loading">
  <div class="shimmer tp-horizontal-icon-card card">
    <i class="fa-thin fa-circle-nodes"></i>
    <div class="tp-horizontal-icon-card-content">
      <h3 class="tp-horizontal-icon-card-title">Starting servers...</h3>
      <span>Your connection information will be available soon</span>
    </div>
  </div>
  <div class="card tp-loading-tip-section">
    <div #loadingTip class="tp-loading-tip">
      <h3>{{ loadingTips[loadingTipIndex].title }}</h3>
      {{ loadingTips[loadingTipIndex].body }}
      @if (loadingTips[loadingTipIndex].code) {
        <div class="tp-code"><tp-code-snippet [snippet]="{ language: 'typeql', code: loadingTips[loadingTipIndex].code! }"/></div>
      }
    </div>
    <div class="tp-loading-tip-buttons">
      <button (click)="prevTip(loadingTip)"><i class="fa-light fa-chevron-left"></i></button>
      <button (click)="nextTip(loadingTip)"><i class="fa-light fa-chevron-right"></i></button>
    </div>
  </div>
</div>
